//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PostComment } from '@/models'
import { mapGetters } from 'vuex'

export default {
  name: 'postComment',
  created() {
    // do something
  },
  props: ['comment'],
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    commentHandler: function() {
      this.$emit('comment', this.comment)
    },
    deleteComment: function() {
      this.$vux.confirm.show({
        title: "操作提示",
        content: "确认删除？",
        onConfirm: () => {
          PostComment.delete(this.comment.objectId).then(() => {
            this.$emit('delete', this.comment)
          })
        }
      })
    }
  },
  components: {
  }
}



// WEBPACK FOOTER //
// ./src/components/PostComment.vue